export default __webpack_public_path__ + "static/media/eye-gray.d9010283.svg";